import React from 'react'
import { Calendar, Clock3, MapPin } from 'lucide-react'

const scheduleGroups = [
  {
    title: 'Morning Session',
    accent: 'blue',
    events: [
      ['8:00 AM - 9:00 AM', 'Dogra Hall', 'Registration'],
      ['09:15 AM - 09:20 AM', 'Dogra Hall', 'Lamp lighting ceremony / Saraswati Vandana'],
      ['09:30 AM - 09:35 AM', 'Dogra Hall', 'Inauguration by Director, IIT Delhi'],
      ['09:35 AM - 10:05 AM', 'Dogra Hall', 'TBA'],
      ['10:10 AM - 10:25 AM', 'Dogra Hall', 'TBA'],
      ['10:25 AM - 10:40 AM', 'Dogra Hall', 'TBA'],
      ['10:40 AM - 10:45 AM', 'Dogra Hall', 'National Anthem'],
    ],
  },
  {
    title: 'Mid-day Session',
    accent: 'green',
    events: [
      ['11:00 AM - 2:30 PM', 'LHC & Blocks', 'Visit to Exhibits & Demonstrations'],
      ['1:00 PM - 2:00 PM', 'Various locations', 'Lunch'],
    ],
  },
  {
    title: 'Afternoon Session',
    accent: 'purple',
    events: [
      ['2:00 PM - 3:30 PM', 'LHC', 'Thematic sessions'],
      ['3:30 PM - 4:00 PM', 'Dogra Hall', 'Closing ceremony and Awards'],
      ['4:00 PM - 4:05 PM', 'Dogra Hall', 'Vote of Thanks by Associate Dean (R&D)'],
    ],
  },
]

const accentStyles = {
  blue: { section: 'border-blue-200', item: 'border-blue-500 bg-blue-50', time: 'bg-blue-100 text-blue-800' },
  green: { section: 'border-green-200', item: 'border-green-500 bg-green-50', time: 'bg-green-100 text-green-800' },
  purple: { section: 'border-purple-200', item: 'border-purple-500 bg-purple-50', time: 'bg-purple-100 text-purple-800' },
}

const Schedule = () => (
  <section className="container mx-auto px-4" aria-labelledby="schedule-title">
    <div className="mb-12 text-center">
      <div className="mb-4 inline-flex items-center gap-2 rounded-full bg-blue-100 px-4 py-2 text-sm font-semibold uppercase tracking-widest text-blue-700">
        <Clock3 className="h-4 w-4" aria-hidden="true" />
        Open House 2026
      </div>
      <h2 id="schedule-title" className="mb-4 text-4xl font-bold text-gray-800 md:text-5xl">Event Schedule</h2>
      <p className="mx-auto max-w-2xl text-lg text-gray-600">Plan your visit with the complete Open House programme.</p>
    </div>

    <div className="mx-auto max-w-4xl overflow-hidden rounded-3xl bg-white shadow-xl ring-1 ring-blue-100">
      <div className="bg-gradient-to-r from-blue-700 to-cyan-600 px-6 py-8 text-white md:px-10">
        <div className="flex flex-col gap-5 sm:flex-row sm:items-center sm:justify-between">
          <div className="flex items-center gap-4">
            <div className="rounded-2xl bg-white/15 p-3 ring-1 ring-white/25"><Calendar className="h-8 w-8" aria-hidden="true" /></div>
            <div><p className="mb-1 text-sm font-medium uppercase tracking-widest text-blue-100">Open House Day</p><h3 className="text-2xl font-bold md:text-3xl">October 31, 2026</h3></div>
          </div>
          <span className="w-fit rounded-full bg-amber-300 px-4 py-2 text-sm font-bold text-amber-950">Full-day programme</span>
        </div>
      </div>

      <div className="space-y-10 px-6 py-8 md:px-10 md:py-10">
        {scheduleGroups.map((group) => {
          const styles = accentStyles[group.accent]
          return (
            <section key={group.title} aria-labelledby={`${group.accent}-session-title`}>
              <h3 id={`${group.accent}-session-title`} className={`mb-4 border-b-2 pb-2 text-lg font-semibold text-gray-700 ${styles.section}`}>{group.title}</h3>
              <div className="space-y-3">
                {group.events.map(([time, venue, event]) => (
                  <article key={`${time}-${event}`} className={`rounded-lg border-l-4 p-4 transition duration-300 hover:-translate-y-0.5 hover:shadow-md ${styles.item}`}>
                    <div className="mb-2 flex flex-col gap-2 sm:flex-row sm:items-center sm:justify-between">
                      <span className={`w-fit rounded-full px-3 py-1 text-sm font-medium ${styles.time}`}>{time}</span>
                      <span className="flex w-fit items-center gap-1 rounded-full bg-yellow-100 px-3 py-1 text-sm font-medium text-yellow-800"><MapPin className="h-3.5 w-3.5" aria-hidden="true" />{venue}</span>
                    </div>
                    <h4 className="font-semibold leading-6 text-gray-800">{event}</h4>
                  </article>
                ))}
              </div>
            </section>
          )
        })}
      </div>
    </div>
  </section>
)

export default Schedule
